import React from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { SOCKET } from '../services/api';

import Actions from '../store/ducks/auth';

const AuthMonitor = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  SOCKET.on('RequestLogout', _data => {
    enqueueSnackbar(
      'Você será desconectado por conta de um login realizado em outro dispositivo.',
      {
        variant: 'error',
        preventDuplicate: true,
        autoHideDuration: 6000,
        onExited: () => dispatch(Actions.logout()),
      },
    );
  });

  return <></>;
};

export default AuthMonitor;
